import React from 'react'
import { observer } from 'mobx-react-lite'
import { ResponseFullDimensions } from '../../controls/preview-report/structure/structureOverviewPreviewReport'
import OverviewFullSummaryReport from '../../controls/preview-report/components/OverviewFullSummaryReport'

let OverviewFullReport: React.FC<any> = ({ state }) => {
    return (
        <>
            {state.dataSource.map(({ ...data }: any, index: number) => {
                if (state.dataSource[0].admin) {
                    return (
                        <React.Fragment key={index}>
                            <div
                                style={{
                                    height: '100%',
                                }}
                            ></div>
                            <OverviewFullSummaryReport
                                containerRef={data.questionnaireRef}
                                fullScore={data.questionnaireScore}
                                questionnaireID={data.questionnaireID}
                                prefixLabel='ด้านที่ '
                                title={data.questionnaireName}
                                //@ts-ignore
                                dataSource={(data.dimensions || []) as DataSource[]}
                                mode='dimension'
                                titleCell='ด้าน'
                            />
                            {data.dimensions.map((dimension: ResponseFullDimensions, index: number) => {
                                return (
                                    <OverviewFullSummaryReport
                                        containerRef={dimension.dimensionRef}
                                        fullScore={data.questionnaireScore}
                                        questionnaireID={data.questionnaireID}
                                        prefixLabel={`เป้าประสงค์ที่ ${index + 1}.`}
                                        title={`ด้านที่ ${dimension.dimensionOrder} ${dimension.name}`}
                                        //@ts-ignore
                                        dataSource={(dimension.purposes || []) as DataSource[]}
                                        mode='purpose'
                                        titleCell='เป้าประสงค์'
                                        key={index}
                                    />
                                )
                            })}
                        </React.Fragment>
                    )
                } else {
                    return (
                        <div
                            style={{
                                textAlign: 'center',
                                width: '100%',
                                fontSize: 24,
                            }}
                        >
                            ไม่มีข้อมูล
                        </div>
                    )
                }
            })}
        </>
    )
}

OverviewFullReport = observer(OverviewFullReport)

export default OverviewFullReport
